import { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';

export const UnstyledButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>((props = {}, ref) => (
  <SyledButton ref={ref} {...props}>
    {props?.children ?? null}
  </SyledButton>
));
UnstyledButton.displayName = 'UnstyledButton';

const SyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
`;
